import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import TrialModal from "../../common/TrialModal";
import { PAGE_LENGTH } from "../../config";
import {
  saveAdvancedSelectedFilters,
  getCompanyListWithStartAndEnd,
  getCompanyList,
  getExecutiveEmployeeList,
  savePaginationValues,
  selectedRow,
} from "../../actionCreator/leadListingActionCreater";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import { AuthContext } from "../../context/AuthContext";
import { getToken } from "../../utils/auth";

export const emptyLeadFilters = (dispatch) => {
  const isAuthenticated = getToken();
  const emptyPayload = {
    selectedCountry: [],
    selectedState: [],
    selectedCity: [],
    selectedIndustry: [],
    selectedCompanytype: [],
    selectedEmployeecount: [],
    selectedRevenuerange: [],
    selectedLeadTime: [],
    selectedLeadRating: [],
    selectedLeadStatus: [],
    selectedFirstName: undefined,
    selectedLeadOwner: undefined,
    selectedLastName: undefined,
    selectedCompanyName: undefined,
    selectedTitle: undefined,
    selectedLeadSource: undefined,
    selectedZipCode: undefined,
  };

  dispatch(saveAdvancedSelectedFilters(emptyPayload));
  dispatch(savePaginationValues({ start: 0, end: 10 }));
  dispatch(selectedRow([]));
  if (isAuthenticated)
    dispatch(getExecutiveEmployeeList({}, { start: 0, end: 10 }));
};

const LeadNavigation = () => {
  const [quickSelection, setQuickSelection] = useState({
    start: 0,
    end: 0,
  });
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const checkLoginStatus = () => {
    let isLoggedIn = false;
    if (isAuthenticated) {
      setShowModal(false);
      isLoggedIn = true;
    } else {
      setShowModal(true);
      isLoggedIn = false;
    }
    return isLoggedIn;
  };

  const onChangeQuickSelection = (e) => {
    setQuickSelection({
      ...quickSelection,
      [e.target.name]: e.target.value,
    });
  };

  const onClickQuickSelection = () => {
    const startValue =
      parseInt(quickSelection?.start) === 1
        ? 0
        : parseInt(quickSelection?.start);

    const pageValues = {
      start: startValue,
      end:
        (parseInt(quickSelection.end) - startValue) * parseInt(PAGE_LENGTH) ||
        PAGE_LENGTH,
    };
    if ((pageValues?.start || pageValues?.start === 0) && pageValues?.end) {
      emptyLeadFilters(dispatch);
      dispatch(getCompanyListWithStartAndEnd(pageValues));
    }
  };

  const onClickSelectAll = () => {
    emptyLeadFilters(dispatch);
    dispatch(getCompanyList());
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const redirectToSignup = () => {
    setShowModal(false);
    navigate("/signup");
  };

  return (
    <nav className="navbar navbar-light bg-white topbar mb-4 mr-2 static-top">
      <div className="buttons-container-top m-mt quickselection">
        {showModal ? (
          <TrialModal
            openModal={showModal}
            closeModal={closeModal}
            redirectToSignup={redirectToSignup}
            buttonText="Start Free Trial"
            redirect={true}
            modalBody={
              <div id="small-dialog2">
                <div align="center">
                  <img src={popupImg} />
                </div>
                <p style={{ color: "#0000FF" }}>
                  Get 10 free verified contacts with a BeyondLeadz Pro trial
                </p>
                <p>
                  BeyondLeadz Pro customers close deals faster thanks to
                  relevant
                </p>
              </div>
            }
            modalWidth="400px"
          />
        ) : (
          ""
        )}
      </div>
    </nav>
  );
};
export default LeadNavigation;
